import React, { useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../Landing.scss";

const Home = ({ banners = [] }) => {
  const [index, setIndex] = useState(0);
  const [loading, setLoading] = useState(banners?.length > 0);

  useEffect(() => {
    if (!banners?.length) {
      setLoading(false);
      return;
    }

    setLoading(true);

    const preloadImages = async () => {
      try {
        await Promise.all(
          banners.map(
            (banner) =>
              new Promise((resolve, reject) => {
                const img = new Image();
                img.src = banner.imageUrl;
                img.onload = resolve;
                img.onerror = () => resolve(); // Resolve gracefully if 1 image fails to load
              })
          )
        );
      } catch (error) {
        console.error("Error loading images:", error);
      } finally {
        setLoading(false);
      }
    };

    preloadImages();

    // Slideshow interval
    const interval = setInterval(() => {
      setIndex((prevIndex) => (prevIndex + 1) % banners.length);
    }, 5000);

    return () => clearInterval(interval);
  }, [banners]);

  if (loading) {
    return (
      <div className="loading-container">
        <div className="loading-bar">
          <div className="loading-progress"></div>
        </div>
        <p>Loading banners...</p>
      </div>
    );
  }

  return (
    <>
      {banners?.length > 0 ? (
        <section className="banner-slider container-fluid p-0 position-relative">
          {banners.map((banner, i) => (
            <div
              key={banner?._id || i} // Fallback to 'i' if _id is missing
              className={`banner-slide ${i === index ? "active" : ""}`}
            >
              <div
                className="parallax-banner"
                style={{
                  backgroundImage: `url(${banner?.imageUrl})`,
                }}
              >
                <div className="banner-overlay"></div>
              </div>
            </div>
          ))}

          {/* Manual Navigation Dots */}
          {banners.length > 1 && (
            <div className="banner-dots-container">
              {banners.map((_, dotIndex) => (
                <button
                  key={dotIndex}
                  type="button"
                  className={`banner-dot ${dotIndex === index ? "active" : ""}`}
                  onClick={() => setIndex(dotIndex)}
                  aria-label={`Go to slide ${dotIndex + 1}`}
                />
              ))}
            </div>
          )}
        </section>
      ) : null}
    </>
  );
};

export default Home;
